import styled from 'styled-components';
import * as Common from '../../../../Styles';

const Theme = Common.Theme;

export const VerticalDivision = styled.div`
	display: flex;
	flex: 1;
	width: 1px;
	height: calc(100vh - 9.4rem);
	border: 1px solid ${Theme.lightGrey};
`;

export const HorizontalDivision = styled.div`
	width: 100%;
	border: 1px solid ${Theme.lightGrey};
`;

export const Section = styled(Common.Container)`
	padding: 0 4rem;
	gap: 0.75rem;
`;

export const SearchRow = styled(Common.FlexRow)`
	gap: 0.5rem;
	align-items: center;
	color: ${Theme.darkGrey};
`;

export const Products = styled(Common.Container)`
  width: auto;
  padding: 0.5rem;
  margin: 0rem;
  min-height: 27.5vh;
  max-height: 27.5vh;
	gap: 0.5rem;
  overflow: overlay;
  border: 1px solid ${Theme.lightGrey};
  border-radius: 4px;
`;